module.exports = __webpack_public_path__ + "static/owlwrap-0788640250d0e321d4779fd6549f319d.jpeg";